(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["calculo-frete"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('dlt-shipping-calculator')) return;

    const moneyFormatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });

    const onlyDigits = (value) => String(value || '').replace(/\D/g, '');

    const formatCep = (value) => {
      const digits = onlyDigits(value).slice(0, 8);
      return digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
    };

    const normalizeQuantity = (value) => {
      const quantity = Number.parseInt(value, 10);
      return Number.isFinite(quantity) ? Math.min(Math.max(quantity, 1), 99) : 1;
    };

    const textNode = (tag, className, value) => {
      const node = document.createElement(tag);
      node.className = className;
      node.textContent = value;
      return node;
    };

    class DltShippingCalculator extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.form = this.querySelector('[data-dlt-shipping-form]');
        this.input = this.querySelector('[data-dlt-shipping-cep]');
        this.button = this.querySelector('[data-dlt-shipping-submit]');
        this.buttonText = this.querySelector('[data-dlt-shipping-button-text]');
        this.feedback = this.querySelector('[data-dlt-shipping-feedback]');
        this.destination = this.querySelector('[data-dlt-shipping-destination]');
        this.destinationText = this.querySelector('[data-dlt-shipping-destination-text]');
        this.results = this.querySelector('[data-dlt-shipping-results]');
        this.dispatch = this.querySelector('[data-dlt-shipping-dispatch]');
        this.scope = this.closest('.product-info, .quick-buy-drawer__info, .shopify-section--main-product') || document;
        this.variants = this.readVariants();
        this.abortController = null;
        this.hasQuoted = false;

        this.form?.addEventListener('submit', (event) => this.onSubmit(event));
        this.input?.addEventListener('input', () => {
          this.input.value = formatCep(this.input.value);
          this.input.removeAttribute('aria-invalid');
        });

        this.scope.addEventListener('change', (event) => this.onProductStateChange(event));
        this.scope.addEventListener('variant:change', () => this.invalidateQuote());
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      readVariants() {
        const source = this.querySelector('[data-dlt-shipping-variants]');
        if (!source) return [];

        try {
          const variants = JSON.parse(source.textContent || '[]');
          return Array.isArray(variants) ? variants : [];
        } catch (_error) {
          return [];
        }
      }

      getProductState() {
        const productForm = this.scope.querySelector('form[action*="/cart/add"]');
        const idField = productForm?.querySelector('[name="id"]');
        const visibleQuantity = this.scope.querySelector('.db-qi, [data-quantity-selector] input, quantity-selector input');
        const quantityField = productForm?.querySelector('[name="quantity"]');
        const variantId = String(idField?.value || this.dataset.defaultVariantId || '');
        const variant = this.variants.find((item) => String(item.id) === variantId) || this.variants[0];

        return {
          sku: String(variant?.sku || '').trim(),
          quantity: normalizeQuantity(visibleQuantity?.value || quantityField?.value || 1)
        };
      }

      onProductStateChange(event) {
        if (!this.hasQuoted) return;

        const target = event.target;
        if (!(target instanceof Element)) return;

        if (target.matches('[name="id"], [name="quantity"], .db-qi, [data-oi]')) {
          this.invalidateQuote();
        }
      }

      invalidateQuote() {
        if (!this.hasQuoted) return;
        this.clearOutput();
        this.showFeedback('Produto ou quantidade alterados. Calcule o frete novamente.', 'info');
        this.hasQuoted = false;
      }

      clearOutput() {
        this.feedback.hidden = true;
        this.feedback.removeAttribute('data-state');
        this.feedback.textContent = '';
        this.destination.hidden = true;
        this.destinationText.textContent = '';
        this.results.hidden = true;
        this.results.replaceChildren();
        if (this.dispatch) this.dispatch.hidden = true;
      }

      showFeedback(message, state = 'info') {
        this.feedback.textContent = message;
        this.feedback.dataset.state = state;
        this.feedback.hidden = false;
      }

      setLoading(isLoading) {
        this.setAttribute('aria-busy', String(isLoading));
        this.button.disabled = isLoading;
        this.buttonText.textContent = isLoading ? 'Calculando' : 'Calcular';
      }

      renderServices(services, cep) {
        this.results.replaceChildren();

        services.forEach((service) => {
          const price = Number(service.price);
          const days = Number.parseInt(service.deliveryDays, 10);
          const item = document.createElement('li');
          item.className = 'dlt-shipping__result';

          const main = document.createElement('div');
          main.appendChild(textNode('p', 'dlt-shipping__result-name', service.name || 'Entrega'));

          const deadline = Number.isFinite(days)
            ? `${days} ${days === 1 ? 'dia útil' : 'dias úteis'}`
            : 'Prazo sob consulta';
          const detail = service.description ? `${deadline} · ${service.description}` : deadline;
          main.appendChild(textNode('p', 'dlt-shipping__result-meta', detail));

          const priceNode = textNode(
            'p',
            'dlt-shipping__result-price',
            price === 0 ? 'Grátis' : moneyFormatter.format(price)
          );
          priceNode.dataset.free = String(price === 0);

          item.append(main, priceNode);
          this.results.appendChild(item);
        });

        this.destinationText.textContent = `Entrega para o CEP ${formatCep(cep)}`;
        this.destination.hidden = false;
        this.results.hidden = false;
        if (this.dispatch) this.dispatch.hidden = false;
      }

      async onSubmit(event) {
        event.preventDefault();
        this.clearOutput();

        const cep = onlyDigits(this.input.value);
        if (cep.length !== 8) {
          this.input.setAttribute('aria-invalid', 'true');
          this.showFeedback('Informe um CEP válido com 8 números.', 'error');
          this.input.focus();
          return;
        }

        const productState = this.getProductState();
        if (!productState.sku) {
          this.showFeedback('Este produto está sem SKU. Fale com nossa equipe para consultar a entrega.', 'error');
          return;
        }

        const endpoint = this.dataset.endpoint || '/apps/dlt-frete/cotar';
        this.abortController?.abort();
        this.abortController = new AbortController();
        const timeout = window.setTimeout(() => this.abortController.abort(), 10000);

        try {
          this.setLoading(true);

          const response = await fetch(endpoint, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              cep,
              items: [{ sku: productState.sku, quantity: productState.quantity }]
            }),
            signal: this.abortController.signal
          });

          const payload = await response.json().catch(() => ({}));
          if (!response.ok) {
            throw new Error(payload?.error?.code || 'quote_failed');
          }

          const services = Array.isArray(payload.services) ? payload.services : [];
          if (!services.length) {
            this.showFeedback('Não encontramos opções de entrega para este CEP no momento.', 'info');
            return;
          }

          this.renderServices(services, cep);
          this.hasQuoted = true;
        } catch (error) {
          if (error.name === 'AbortError') {
            this.showFeedback('A consulta demorou mais que o esperado. Tente novamente.', 'error');
          } else if (error.message === 'invalid_sku') {
            this.showFeedback('Não foi possível localizar este produto na integração de frete.', 'error');
          } else {
            this.showFeedback('Não foi possível calcular o frete agora. Tente novamente em instantes.', 'error');
          }
        } finally {
          window.clearTimeout(timeout);
          this.setLoading(false);
        }
      }
    }

    customElements.define('dlt-shipping-calculator', DltShippingCalculator);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dlt-share-actions"] && !Shopify.designMode) return;
  try {
    const dltShareWriteClipboard = async (value) => {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(value);
    return;
  }

  const textArea = document.createElement('textarea');
  textArea.value = value;
  textArea.setAttribute('readonly', '');
  textArea.style.position = 'fixed';
  textArea.style.opacity = '0';
  textArea.style.pointerEvents = 'none';
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand('copy');
  textArea.remove();
};

const dltShareFeedback = (status, message, timeout = 3200) => {
  if (!status) return;

  window.clearTimeout(status.__dltShareTimer);
  status.textContent = message || '';
  status.classList.toggle('is-visible', Boolean(message));

  if (message && timeout > 0) {
    status.__dltShareTimer = window.setTimeout(() => {
      status.textContent = '';
      status.classList.remove('is-visible');
    }, timeout);
  }
};

const dltShareInit = (scope = document) => {
  const closeSharePanels = (exceptRoot = null) => {
    document.querySelectorAll('[data-dlt-share-actions].is-collapsible').forEach((shareRoot) => {
      if (exceptRoot && shareRoot === exceptRoot) return;
      const button = shareRoot.querySelector('[data-dlt-share-toggle]');
      const panel = shareRoot.querySelector('[data-dlt-share-panel]');
      if (!button || !panel) return;
      button.setAttribute('aria-expanded', 'false');
      button.classList.remove('is-open');
      panel.hidden = true;
    });
  };

  scope.querySelectorAll('[data-dlt-share-actions]').forEach((root) => {
    if (root.dataset.dltShareReady === 'true') return;
    root.dataset.dltShareReady = 'true';

    const toggleButton = root.querySelector('[data-dlt-share-toggle]');
    const panel = root.querySelector('[data-dlt-share-panel]');
    const copyButton = root.querySelector('[data-dlt-copy-link]');
    const status = root.querySelector('[data-dlt-share-status]');

    if (toggleButton && panel) {
      panel.hidden = true;
      toggleButton.addEventListener('click', () => {
        const isOpen = toggleButton.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          toggleButton.setAttribute('aria-expanded', 'false');
          toggleButton.classList.remove('is-open');
          panel.hidden = true;
        } else {
          closeSharePanels(root);
          toggleButton.setAttribute('aria-expanded', 'true');
          toggleButton.classList.add('is-open');
          panel.hidden = false;
        }
      });
    }

    if (copyButton) {
      copyButton.addEventListener('click', async () => {
        const url = copyButton.dataset.copyUrl || window.location.href;
        const successMessage = copyButton.dataset.copySuccess || 'Link copiado.';

        try {
          await dltShareWriteClipboard(url);
          copyButton.classList.add('is-copied');
          dltShareFeedback(status, successMessage, 2200);

          window.setTimeout(() => copyButton.classList.remove('is-copied'), 1800);
        } catch (error) {
          dltShareFeedback(status, 'Não foi possível copiar o link.', 3000);
        }
      });
    }
  });

  if (!document.documentElement.dataset.dltShareBound) {
    document.documentElement.dataset.dltShareBound = 'true';

    document.addEventListener('click', (event) => {
      const root = event.target.closest('[data-dlt-share-actions].is-collapsible');
      if (!root) closeSharePanels();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeSharePanels();
    });
  }
};

dltShareInit();
document.addEventListener('shopify:section:load', (event) => dltShareInit(event.target));
  } catch(e) { console.error(e); }
})();

})();
